import { AfterViewInit, Component } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { NgxSonnerToaster } from 'ngx-sonner';
import { ThemeService } from './core/services/theme.service';
import { ResponsiveHelperComponent } from './shared/components/responsive-helper/responsive-helper.component';

import FHIR, { client } from "fhirclient";
import { error } from 'console';
import { AppService } from './app.service';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { AuthService } from './auth.service'; // adjust path
import { CommonModule } from '@angular/common';
import { first, interval, Subscription } from 'rxjs';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, ResponsiveHelperComponent, NgxSonnerToaster, CommonModule],
})
export class AppComponent implements AfterViewInit {
  title = 'Smart Apps';

  private intervalId: any;
  constructor(
    private _appService: AppService,
    // public auth: AuthService,
    public themeService: ThemeService,
    private activatedRoute: ActivatedRoute,
    private appService: AppService
  ) {


  }
  private subscription!: Subscription;
  private tempToken: string = "";

  ngOnInit(): void {



  }


  ngAfterViewInit() {

    //In this process app will check the param of the url on #
    // if the url contain temporary token, it will call an api to verify
    // if the url doesnt contain temporary token it will running as standlone
    this.activatedRoute.fragment.subscribe((token) => {
      //Check temporary token is null or not
      if (token != null && token != '') {
        //verify the temporary token by api
        this.tempToken = token;
        this.verifyTempToken(token!);
        console.log("ada token")
      } else {
        console.log("xde token")
        // this.auth.login();
        //no token available
      }
    });

    // Call the function every 5 seconds
    this.subscription = interval(5000).subscribe(() => {
      this.doRefreshToken();
    });
  }


  verifyTempToken(token: string) {
    this._appService.verifyToken(token).subscribe((x) => {

      var json = JSON.stringify(x);
      var data = JSON.parse(json);
      console.log("aa", data);
      sessionStorage.setItem('subject', data.subject);
      sessionStorage.setItem('access_token', data.access_token);
      sessionStorage.setItem('expires_in', data.expires_in);
      sessionStorage.setItem('refresh_expires_in', data.refresh_expires_in);
      sessionStorage.setItem('refresh_token', data.refresh_token);
      sessionStorage.setItem('session_state', data.session_state);
      sessionStorage.setItem('scope', data.scope);
      localStorage.setItem('practitionerId', data.practitionerId);
      localStorage.setItem('organizationId', data.organizationId);
      localStorage.setItem('patientId', data.patientId);
      localStorage.setItem('locationId', data.locationId);
      localStorage.setItem('encounterId', data.encounterId);
      localStorage.setItem('branchCode', data.branchCode);
      localStorage.setItem('departmentCode', data.departmentCode);
      localStorage.setItem('recordStatus', data.recordStatus);
      localStorage.setItem('practitionerRoleId', data.practitionerRoleId);
      localStorage.setItem('practitionerName', data.practitionerName);
    });

  }

  doRefreshToken(): void {
    let payload = {
      access_token: sessionStorage.getItem("access_token"),
      refresh_token: sessionStorage.getItem("refresh_token")
    }
    this._appService.refreshToken(payload).subscribe((x) => {

      var json = JSON.stringify(x);
      var data = JSON.parse(json);
      sessionStorage.setItem('access_token', data.access_token);
      sessionStorage.setItem('expires_in', data.expires_in);
      sessionStorage.setItem('refresh_expires_in', data.refresh_expires_in);
      sessionStorage.setItem('refresh_token', data.refresh_token);
      sessionStorage.setItem('session_state', data.session_state);
      sessionStorage.setItem('scope', data.scope);
    })
    // Call API or run logic
  }

  ngOnDestroy(): void {
    // Clean up to prevent memory leaks
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
